import React, { FC } from 'react';
import styled from 'styled-components';
import { Content } from './content';

const Comment = styled(Content)`
  --rte-readonly-content-padding: 0 40px 0 0;
  flex: 1 1;
  padding: var(--base-unit);
`;

const Container = styled.div<{ $background?: string }>`
  align-items: center;
  display: flex;
  width: 80%;
  ${Comment} {
    ${({ $background }) => $background && `background: ${$background}`};
  }
`;

const IconWrapper = styled.div`
  margin-right: 12px;
`;

export const ApprovalComment: FC<{
  content: string;
  icon: React.ReactNode;
  background?: string;
}> = ({ content, icon, background }) => {
  return (
    <Container $background={background}>
      <IconWrapper>{icon}</IconWrapper>
      <Comment data={content} />
    </Container>
  );
};
